// message.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    private newMessageAvailableSubject = new BehaviorSubject<boolean>(false);

    // Observable to expose
    newMessageAvailable$: Observable<boolean> = this.newMessageAvailableSubject.asObservable();

    // Method to update the value
    setNewMessageAvailable(value: boolean): void {
        this.newMessageAvailableSubject.next(value);
    }
}
